import { makeStyles } from 'tss-react/mui';

const useStylesBadge: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  badge: {
    '& > span': {
      color: theme.palette.common.white,
    },
  },
  badgeCompact: {
    right: '25% !important',
    top: '25% !important',
  },
}));

export default useStylesBadge;
